import { Folder, LayoutDashboard, Users } from 'lucide-react';
import { Map, Settings } from 'lucide-react';
import { useNavigate } from 'react-router';
import { UserRole } from '@/types/enums';
import { useAuth } from '@/providers/AuthProvider';

interface DashboardSidebarProps {
  isOpen: boolean;
}

export const Sidebar = ({ isOpen }: DashboardSidebarProps) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const adminNavItems = [
    {
      icon: <LayoutDashboard size={18} />,
      text: 'Dashboard',
      path: '/admin/dashboard',
    },
    {
      icon: <Folder size={18} />,
      text: 'Project Management',
      path: '/admin/project-management',
    },
    { icon: <Map size={18} />, text: 'Map View', path: '/admin/ticket-map' },
    {
      icon: <Users size={18} />,
      text: 'Crew Management',
      path: '/admin/crew-management',
    },
    { icon: <Settings size={18} />, text: 'Settings', path: '/admin/settings' },
  ];

  const crewNavItems = [
    {
      icon: <LayoutDashboard size={18} />,
      text: 'Dashboard',
      path: '/crew/ticket-map',
    },
  ];

  const navItems = user?.role === UserRole.ADMIN ? adminNavItems : crewNavItems;

  return (
    <aside
      className={`fixed top-16 left-0 h-[calc(100vh-4rem)] w-64 bg-shell shadow-md border-inputtransform lg:translate-x-0 transition-transform duration-300 ease-in-out z-50 ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      }`}
    >
      <div className="p-4 h-full flex flex-col">
        {/* Navigation */}
        <nav className="flex-1">
          <ul className="space-y-2">
            {navItems.map((item, index) => {
              const isActive = location.pathname === item.path;
              return (
                <li key={index}>
                  <button
                    onClick={() => navigate(item.path)}
                    className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-sm font-medium cursor-pointer transition-colors duration-200
                  ${
                    isActive
                      ? 'bg-teal-700 text-white dark:bg-secondary dark:text-secondary-foreground  '
                      : 'text-teal-100 hover:bg-teal-600/40 hover:text-white dark:hover:bg-secondary/10'
                  }`}
                  >
                    {item.icon}
                    <span>{item.text}</span>
                    {isActive && (
                      <span className="ml-auto h-2 w-2 rounded-full bg-secondary dark:bg-secondary-foreground"></span>
                    )}
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Footer */}
        <div className="p-4 border-t border-border">
          <div className="text-center">
            <div className="text-center">
              <p className="text-xs text-gray-100 mb-1">
                &copy; {new Date().getFullYear()} Ulaa FieldOps
              </p>
              <p className="text-xs text-gray-300">All rights reserved</p>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};
